export const CardDashboard = ({ children, className }) => <div className={className}>{children}</div>;